export const actions = {
  CREATE_OBJECTIVE: 'CREATE_OBJECTIVE',
  CREATE_OBJECTIVE_KR_CHECKINS: 'CREATE_OBJECTIVE_KR_CHECKINS',
  GET_AI_SUGGESTED_OKR_TITLE: 'GET_AI_SUGGESTED_OKR_TITLE',
  GET_KRS_SUGGESTED_BY_AI_ON_OBJECTIVE: 'GET_KRS_SUGGESTED_BY_AI_ON_OBJECTIVE'
};

export const postCreateObjective = (
  requestBody,
  rootObjectiveIndex,
  callback
) => ({
  type: actions.CREATE_OBJECTIVE,
  requestBody,
  rootObjectiveIndex,
  callback
});

export const postCreateObjectiveAndKeyResultsWithCheckIns = (
  requestBody,
  callback
) => ({
  type: actions.CREATE_OBJECTIVE_KR_CHECKINS,
  requestBody,
  callback
});

export const getAiGeneratedOkrTitle = (prompt, callback) => ({
  type: actions.GET_AI_SUGGESTED_OKR_TITLE,
  prompt,
  callback
});

export const getAiGeneratedKrsBasedOnOkrTitle = (prompt, callback) => ({
  type: actions.GET_KRS_SUGGESTED_BY_AI_ON_OBJECTIVE,
  prompt,
  callback
});
